import React from "react";
import { AddonTask } from "@coworker/types/lib/tasks/addon";
import { useAllSalesLocationsForArticleQuery } from "./useAllSalesLocationsForArticleQuery";
import useFlag, { FLAGS } from "../useFlag";
import { joinLocation } from "../../services/locations.service";

const foodHFBs = ["60", "61"];
const isSFM = (panumber: string) =>
  foodHFBs.includes((panumber || "").slice(0, 2));

function makePickupFields(storeLocation: string, locationDescription: string) {
  return {
    pickup_location: joinLocation(storeLocation, locationDescription),
    pickup_location_grid_code: storeLocation,
    pickup_location_department: locationDescription,
    pickup_location_custom: "",
  };
}

export function useTaskFormDefaultPickupFields(task: AddonTask) {
  const short_id = task?.product_article_id;
  const type = task?.product_article_type;
  const panumber = task?.panumber as string;

  const { data: locationsData, isLoading } =
    useAllSalesLocationsForArticleQuery(
      !!short_id && !!type ? `${type}${short_id}` : ""
    );
  const pickupFieldsExperiment = useFlag(FLAGS.BETTER_PICKUP);

  return React.useMemo(() => {
    if (!short_id) return null;

    if (!isLoading && locationsData) {
      if (isSFM(panumber)) {
        return makePickupFields("SFM", "Swedish Food Market");
      }

      let homeLoc = null;
      let primaryLoc = null;
      if (locationsData) {
        for (const loc of locationsData) {
          if (loc?.isHome || loc?.isHomeBase) homeLoc = loc;
          if (loc?.isPrimary) primaryLoc = loc;
        }
      }
      const found = (pickupFieldsExperiment && primaryLoc) || homeLoc;
      if (!found) return null;
      return makePickupFields(
        found.storeLocation || found.location,
        found.locationDescription || found.descriptive
      );
    }
    return null;
  }, [locationsData, panumber, short_id, pickupFieldsExperiment, isLoading]);
}
